<template>
    <h1>Vista de Tendencias</h1>
</template>
<script>
export default {
    
}
</script>
<style>

</style>
